import React, { useEffect, useState } from 'react';
import IconLink from '../Menus/IconLink';
import { PAGES, ROUTE_PATHS } from "../../InternalApiApp";
import { Edit, Settings, LogOut, BookOpen, User, BarChart2, Edit3, UserCheck, RefreshCw, HelpCircle, Video } from 'react-feather';
import { useStorage, getSidebarRouteByPermissions, useRemote } from '../../Utils/Utils';
import { useHistory } from 'react-router';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SideBarWrapper, { SideBarIconGroup } from './SideBarWrapper';
import ActiveWorkFlowIcon from '../../images/icons/ActiveWorkflowIcon';


const SideBarLeft = ({ jsonFile, isExternalManager, me, helpPage }) => {
	const locationHook = useLocation()
	const location = locationHook.pathname

	const [draftsCounter, setDraftsCounter] = useState(0)
	const [peerCounter, setPeerCounter] = useState(0)
	const [requestsCounter, setRequestsCounter] = useState(0)

	const checkRoute = (route) => {
		return route === "/" && location?.includes("delivery") ? true :
			route === "/" ? location === route :
				location?.startsWith(route) && location?.includes("delivery") ? false :
					location?.startsWith(route)
	}

	const storage = useStorage();
	const remote = useRemote();
	const history = useHistory();

	const logout = () => {
		remote.get("/crm/logout").then((obo) => {
			//if we're impersonating, we'll have new access.
			if (obo && obo.data) {
				window.location.href = `/?${Math.random()}`;
			} else {
				history.push("/sign-in");
			}
			//remote.logout();
		})
	}

	useEffect(() => {
		!isExternalManager && hasPermissionFor("DRAFTS_COMPLIANCE") && storage.getOrFetch("/documents/requests").then((res) => setRequestsCounter(res && res.length ? res.length : 0));
		!isExternalManager && hasPermissionFor(["DRAFTS_ANALYST", "DRAFTS_PEER"]) && storage.getOrFetch("/documents/drafts").then(countDraftsAndPeerRequests);
		!isExternalManager && hasPermissionFor("DRAFTS_COMPLIANCE") && storage.watch("/documents/requests", (res) => setRequestsCounter(res && res.length ? res.length : 0));
		!isExternalManager && hasPermissionFor(["DRAFTS_ANALYST", "DRAFTS_PEER"]) && storage.watch("/documents/drafts", countDraftsAndPeerRequests);

		return () => {
			!isExternalManager && hasPermissionFor("DRAFTS_COMPLIANCE") && storage.unwatch("/documents/requests")
			!isExternalManager && hasPermissionFor(["DRAFTS_ANALYST", "DRAFTS_PEER"]) && storage.unwatch("/documents/drafts")
		}
	}, [])

	const countDraftsAndPeerRequests = (list) => {
		let drafts = 0
		let peers = 0
		if (list) {
			list.forEach((doc) => {
				if (doc.peerReview !== "pending") {
					peers++
				} else {
					drafts++
				}
			})
		}
		setDraftsCounter(drafts)
		setPeerCounter(peers)
	}

	const hasPermissionFor = (permission) => {
		if (Array.isArray(permission)) return permission.some(p => me && me.perms.includes(p));
		return me && me.perms.includes(permission);
	}

	let draftsNum = 0
	if (hasPermissionFor("DRAFTS_ANALYST")) draftsNum = draftsNum + draftsCounter
	if (hasPermissionFor("DRAFTS_PEER")) draftsNum = draftsNum + peerCounter

	return (
		<SideBarWrapper borderRight left>
			<SideBarIconGroup>
				{(hasPermissionFor("EDIT") || hasPermissionFor("EXTERNAL_EDITOR")) && <IconLink
					icon={<Edit />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.EDITOR])}
					active={checkRoute(ROUTE_PATHS[PAGES.EDITOR])}
					label="Editor"
				/>}
				{(hasPermissionFor("LIBRARY_VIEW") || isExternalManager) && <IconLink
					icon={<BookOpen />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.LIBRARY])}
					active={checkRoute(ROUTE_PATHS[PAGES.LIBRARY])}
					label="Library"
					disabled={isExternalManager}
				/>}
				<IconLink
					icon={<ActiveWorkFlowIcon />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.ACTIVE_WORKFLOWS])}
					active={checkRoute(ROUTE_PATHS[PAGES.ACTIVE_WORKFLOWS])}
					label="Workflow Monitor"
					disabled={isExternalManager}
				/>
				{(hasPermissionFor("DATA_MANAGEMENT") || isExternalManager) && <IconLink
					icon={<RefreshCw />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.DATA_MANAGEMENT])}
					active={checkRoute(ROUTE_PATHS[PAGES.DATA_MANAGEMENT])}
					label="Data Manager"
					disabled={isExternalManager}
				/>}
				{hasPermissionFor(["DRAFTS_COMPLIANCE", "DRAFTS_PEER", "DRAFTS_SPOT", "REVIEW_SPOT", "REQUEST_PEER", "REQUEST_COMPLIANCE"]) && <IconLink
					icon={<UserCheck />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.REQUESTS])}
					active={checkRoute(ROUTE_PATHS[PAGES.REQUESTS])}
					label="Requests"
					counter={requestsCounter}
					disabled={isExternalManager}
				/>}
				{(hasPermissionFor(["DRAFTS_ANALYST", "DRAFTS_PEER"]) || isExternalManager) && <IconLink
					icon={<Edit3 />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.DRAFTS])}
					active={checkRoute(ROUTE_PATHS[PAGES.DRAFTS])}
					label="Drafts"
					counter={draftsNum}
					disabled={isExternalManager}
				/>}
				{(hasPermissionFor("ANALYTICS_VIEW") || isExternalManager) && <IconLink
					icon={<BarChart2 />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.ANALYTICS] + jsonFile.mainTab.path)}
					active={checkRoute(ROUTE_PATHS[PAGES.ANALYTICS])}
					label="Analytics"
					disabled={isExternalManager}
				/>}
				{(hasPermissionFor(["USERS", "COMPANIES", "DISTRIBUTION", "SUPPRESSED_EMAILS"]) || isExternalManager) && <IconLink
					icon={<User />}
					onClick={() => history.push(getSidebarRouteByPermissions("clientManagement", me && me.perms))}
					active={checkRoute(ROUTE_PATHS[PAGES.CRM])}
					label="CRM"
					disabled={isExternalManager}
				/>}
				{(hasPermissionFor(["TICKERS", "MODEL_PORTFOLIOS", "ASSET_CLASS_MGT", "SECTORS", "DISCLAIMER", "USER_MANAGEMENT", "COMPANY_MANAGEMENT", "PORTFOLIO_MANAGEMENT", "ROLES", "TEMPLATES", "IMPERSONATE"]) || isExternalManager) && <IconLink
					icon={<Settings />}
					onClick={() => history.push(getSidebarRouteByPermissions("admin", me && me.perms))}
					active={checkRoute(ROUTE_PATHS[PAGES.ADMIN])}
					label="Settings"
					disabled={isExternalManager}
				/>}
				{helpPage && <IconLink
					icon={<HelpCircle />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.HELP])}
					active={checkRoute(ROUTE_PATHS[PAGES.HELP])}
					label="Help"
				/>}
				{process.env.NODE_ENV === 'development' && <IconLink
					icon={<Video />}
					onClick={() => history.push(ROUTE_PATHS[PAGES.BUNNY_TEST])}
					active={checkRoute(ROUTE_PATHS[PAGES.BUNNY_TEST])}
					label="Bunny Test"
				/>}

			</SideBarIconGroup>
			<SideBarIconGroup className="mt-auto">
				<IconLink
					icon={<LogOut />}
					onClick={logout}
					active={false}
					label="Logout"
				/>
			</SideBarIconGroup>
		</SideBarWrapper>
	)
};

export default SideBarLeft;